import { FC } from "react";
import { useRecoilValue } from "recoil";

import { AccessControl } from "@ryde/controls";
import {
  ActionsEnum,
  editFormDataAF,
  IRideDto,
  RideCrudModeKey,
  RideCrudModeKeyTuple,
} from "@ryde/shared";

import { HeaderRightButtonsStyled } from "../../../../header";
import { LayoutRightHistoryButton } from "../../../../right";
import { useRideHeaderPriceVisibility } from "./hooks";
import { RebuildRouteDropdown } from "./rebuild-route-dropdown";
import { RideHeaderPrice } from "./ride-header-price";
import { RideHeaderPriceSupplier } from "./ride-header-price-supplier";
import { RideInvestigateButton } from "./ride-investigate-button";
import { RideMeasuredTimesButton } from "./ride-measured-times-button";
import { RideRebuildButton } from "./ride-rebuild-button";

export const RideHeaderButtons: FC = () => {
  const rideDto = useRecoilValue<Partial<IRideDto> | undefined>(
    editFormDataAF(RideCrudModeKeyTuple),
  );
  const { shouldShowClientPrice, shouldShowSupplierPrice } =
    useRideHeaderPriceVisibility();

  return (
    rideDto && (
      <HeaderRightButtonsStyled className="RideDrawer-HeaderButtons">
        <RideRebuildButton rideDto={rideDto} />
        <RebuildRouteDropdown rideDto={rideDto} />
        <AccessControl entity="system" action={ActionsEnum.ViewPrices}>
          {shouldShowClientPrice && <RideHeaderPrice rideDto={rideDto} />}
        </AccessControl>
        <AccessControl entity="system" action={ActionsEnum.ViewSupplierPrices}>
          {shouldShowSupplierPrice && (
            <RideHeaderPriceSupplier rideDto={rideDto} />
          )}
        </AccessControl>
        <RideMeasuredTimesButton rideDto={rideDto} />
        <RideInvestigateButton rideDto={rideDto} />
        <LayoutRightHistoryButton
          entity={RideCrudModeKey.uiUnit}
          dtoId={rideDto?.id}
        />
      </HeaderRightButtonsStyled>
    )
  );
};
